 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-2d0ab0d7":"75e23ae0","chunk-2d0b2f18":"78f33553","chunk-2d0b34aa":"3f14ee02","chunk-2d0b64ec":"2edf553f","chunk-2d0b7220":"6a0e2802","chunk-2d0bcda8":"53a3fd44","chunk-2d0d3868":"e237d029","chunk-2d0d4066":"5fb64eea","chunk-2d0d439b":"fe40de4d","chunk-2d0d72b0":"5f4c1ce8","chunk-2d0d7ae2":"d1ae236e","chunk-2d0da512":"8fa82dfc","chunk-2d0dd4be":"50dc5fef","chunk-2d0e1462":"54bc67df","chunk-2d0e26e8":"c69f6edc","chunk-2d0e4e7a":"0bdbb2b4","chunk-2d0e5f81":"e8f9664d","chunk-2d0e97b0":"78b9b373","chunk-2d2077b2":"50090900","chunk-2d20eb8b":"a8fb44ed","chunk-2d213c7e":"adb17e43","chunk-2d216d17":"c7f490ac","chunk-2d21e1d3":"5d0d970c","chunk-2d228fbe":"c08afb8e","chunk-2d229294":"a2e30d63","chunk-2d2304e1":"ada32ec8","chunk-2d237761":"9207bca8","chunk-3b9068e5":"52f015b5","chunk-434dc201":"f17ec612","chunk-4ea13cc1":"303d29aa","chunk-2361e742":"a33032f4","chunk-59c6b484":"e0c065bd","chunk-644ecc00":"03d7262b","chunk-74839a04":"02b33f8e","chunk-f232fd70":"f06e94f7","chunk-7e58daf4":"9fea7251","chunk-3bf97642":"3b1e1985","chunk-212c398e":"3d3522fe","chunk-6da381b1":"b936efac","chunk-3e98ab19":"1f83bc14","chunk-e6d9a3e2":"0a9548c4","chunk-9a532098":"86563835","chunk-2d0d3dcd":"d55453bc","chunk-2d0e53c5":"db76845a","chunk-34bd1fe1":"a8d85cab","chunk-40b5323a":"e60a6655","chunk-c4764552":"7bc1a040"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-434dc201":1,"chunk-4ea13cc1":1,"chunk-2361e742":1,"chunk-59c6b484":1,"chunk-644ecc00":1,"chunk-7e58daf4":1,"chunk-3bf97642":1,"chunk-212c398e":1,"chunk-3e98ab19":1,"chunk-e6d9a3e2":1,"chunk-9a532098":1,"chunk-34bd1fe1":1,"chunk-c4764552":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-2d0ab0d7":"31d6cfe0","chunk-2d0b2f18":"31d6cfe0","chunk-2d0b34aa":"31d6cfe0","chunk-2d0b64ec":"31d6cfe0","chunk-2d0b7220":"31d6cfe0","chunk-2d0bcda8":"31d6cfe0","chunk-2d0d3868":"31d6cfe0","chunk-2d0d4066":"31d6cfe0","chunk-2d0d439b":"31d6cfe0","chunk-2d0d72b0":"31d6cfe0","chunk-2d0d7ae2":"31d6cfe0","chunk-2d0da512":"31d6cfe0","chunk-2d0dd4be":"31d6cfe0","chunk-2d0e1462":"31d6cfe0","chunk-2d0e26e8":"31d6cfe0","chunk-2d0e4e7a":"31d6cfe0","chunk-2d0e5f81":"31d6cfe0","chunk-2d0e97b0":"31d6cfe0","chunk-2d2077b2":"31d6cfe0","chunk-2d20eb8b":"31d6cfe0","chunk-2d213c7e":"31d6cfe0","chunk-2d216d17":"31d6cfe0","chunk-2d21e1d3":"31d6cfe0","chunk-2d228fbe":"31d6cfe0","chunk-2d229294":"31d6cfe0","chunk-2d2304e1":"31d6cfe0","chunk-2d237761":"31d6cfe0","chunk-3b9068e5":"31d6cfe0","chunk-434dc201":"7f1b9444","chunk-4ea13cc1":"f2b920bc","chunk-2361e742":"151ee4ad","chunk-59c6b484":"7f1b9444","chunk-644ecc00":"ea84458f","chunk-74839a04":"31d6cfe0","chunk-f232fd70":"31d6cfe0","chunk-7e58daf4":"e0ad69bd","chunk-3bf97642":"286c3c62","chunk-212c398e":"fe247e94","chunk-6da381b1":"31d6cfe0","chunk-3e98ab19":"630c8ffd","chunk-e6d9a3e2":"630c8ffd","chunk-9a532098":"16d7e6bc","chunk-2d0d3dcd":"31d6cfe0","chunk-2d0e53c5":"31d6cfe0","chunk-34bd1fe1":"5fbd4859","chunk-40b5323a":"31d6cfe0","chunk-c4764552":"9376475e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.mag.travel/ui/app/prod/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
